module.exports = __webpack_public_path__ + "static/img/ubud.e251d20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hotel/ubud.jpg
// module id = GEzS
// module chunks = 1